import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
    providedIn: 'root'
})
export class BuyerChargesInvoiceService {

    constructor(private _http: HttpClient) { }

    invoicerecords(data) {
        return this._http.post(environment.api_url + 'buyer/report/chargeinvoice', data);
    }

    generatechargesinvoice(data) {
        return this._http.post(environment.api_url + 'buyer/chargeinvoice/generate', data);
    }

}